var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 15.8346C11.8403 15.8346 13.3327 14.3423 13.3327 12.5013C13.3327 10.6604 11.8403 9.16797 9.99935 9.16797C8.1584 9.16797 6.66602 10.6604 6.66602 12.5013C6.66602 14.3423 8.1584 15.8346 9.99935 15.8346Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69922 12.5003L9.24089 13.0419C9.39922 13.2003 9.65755 13.2086 9.81589 13.0503L11.2992 11.6836",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49937 18.3346H12.4994C15.8494 18.3346 16.4494 16.993 16.6244 15.3596L17.2494 10.3596C17.4744 8.3263 16.891 6.66797 13.3327 6.66797H6.66603C3.1077 6.66797 2.52437 8.3263 2.74937 10.3596L3.37437 15.3596C3.54937 16.993 4.14937 18.3346 7.49937 18.3346Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.38996V5.58163C6.25 3.70663 7.75833 1.86496 9.63333 1.68996C11.8667 1.4733 13.75 3.23163 13.75 5.4233V6.5733",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.752aadfac3450411efd151322c3ca538.svg";
export { ForwardRef as ReactComponent };